// extracted by mini-css-extract-plugin
module.exports = {"HeaderElementHamburger":"HeaderElementHamburger_HeaderElementHamburger__29hdM","hamburgerIconWrapper":"HeaderElementHamburger_hamburgerIconWrapper__1owsZ"};